import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { segmentApi } from '@edulastic/api'
import { IconStar, IconPDLSparkle } from '@edulastic/icons'
import { roleuser } from '@edulastic/constants'
import connect from 'react-redux/es/connect/connect'
import { compose } from 'redux'
import { StyledCustomContentGenerationButton } from './styled'
import { TooltipStyled } from '../../Dashboard/components/Showcase/components/Myclasses/components/CardAssignmentContent/styled'
import { navigationState } from '../../src/constants/navigation'
import SignupAndTrialModals from '../../AssessmentCreate/components/SignupAndTrialModals'
import { getUserRole, isPremiumUserSelector } from '../../src/selectors/user'
import { getIsSubscriptionExpired } from '../../Subscription/ducks'
import {
  CUSTOM_CONTENT_BUTTON_INFO,
  CUSTOM_CONTENT_BUTTON_TYPES,
} from './CustomContentGeneration/constants'

const CustomContentGenerationButton = ({
  buttonType,
  isPremiumUser,
  handleIsMasteryRangeAndStudentSelectVisible,
  isFiftyPercentClassGraded,
  history,
  hasTeacherPremiumSubscriptionExpired,
  userRole,
  handleStandardIdChange,
  currentStandardId,
}) => {
  const [showFreeTrialModalsFlow, setShowFreeTrialModalsFlow] = useState(false)
  const isButtonDisabled = !isFiftyPercentClassGraded || !isPremiumUser

  const handleClick = () => {
    if (!isPremiumUser) {
      if (
        hasTeacherPremiumSubscriptionExpired ||
        userRole !== roleuser.TEACHER
      ) {
        history.push({
          pathname: '/author/subscription',
          state: { view: navigationState.SUBSCRIPTION.view.ADDON },
        })
      } else {
        setShowFreeTrialModalsFlow(true)
      }
    } else {
      if (isButtonDisabled) {
        return
      }
      if (buttonType === CUSTOM_CONTENT_BUTTON_TYPES.IMPROVE_MASTERY) {
        handleStandardIdChange(currentStandardId)
      } else {
        handleStandardIdChange('')
      }
      handleIsMasteryRangeAndStudentSelectVisible(true)
      segmentApi.genericEventTrack(`StandardBasedReport:${buttonType}:Click`, {
        source: 'LCB:StandardBasedReport',
      })
    }
  }

  const trialSuccessHandle = () => {
    setShowFreeTrialModalsFlow(false)
    handleIsMasteryRangeAndStudentSelectVisible(true)
  }

  let tooltipText = ''
  if (!isPremiumUser) {
    tooltipText =
      'Upgrade to Premium or Enterprise to unlock targeted intervention features.'
  } else if (!isFiftyPercentClassGraded) {
    tooltipText = 'Available once 50% of students have been graded.'
  } else {
    tooltipText = CUSTOM_CONTENT_BUTTON_INFO[buttonType].tooltipText
  }

  return (
    <>
      {showFreeTrialModalsFlow && (
        <SignupAndTrialModals
          onCancel={() => setShowFreeTrialModalsFlow(false)}
          onTrialSubsConfirmation={trialSuccessHandle}
        />
      )}
      <TooltipStyled
        placement="bottom"
        $bgColor="white"
        $color="#777777"
        title={tooltipText}
        overlayStyle={{ maxWidth: 300 }}
      >
        <span>
          <StyledCustomContentGenerationButton
            isButtonDisabled={isButtonDisabled}
            onClick={handleClick}
            data-cy={buttonType}
          >
            <IconPDLSparkle width="14" height="14" />
            <span>{CUSTOM_CONTENT_BUTTON_INFO[buttonType].buttonText}</span>
            {!isPremiumUser && <IconStar />}
          </StyledCustomContentGenerationButton>
        </span>
      </TooltipStyled>
    </>
  )
}

const mapStateToProps = (state) => ({
  hasTeacherPremiumSubscriptionExpired: getIsSubscriptionExpired(state),
  userRole: getUserRole(state),
  isPremiumUser: isPremiumUserSelector(state),
})

const enhance = compose(withRouter, connect(mapStateToProps))

export default enhance(CustomContentGenerationButton)
